import React from 'react';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-xl-center gy-5">

          <div className="col-xl-5 content">
            <h3>About Us</h3>
            <h2>Empower Your Business with Exceptional Solutions</h2>
            <p>
            Welcome to Digisoft, your dependable ally for maximizing the potential of cutting-edge technology. At Digisoft, we're dedicated to providing cutting-edge solutions that will support businesses in thriving in today's fast-paced digital environment. We give businesses the tools they need to keep one step ahead of the competition by focusing on TallyPrime, cloud computing, SharePro, and many other technological developments.
            </p>
            <p>
              At Digisoft, we transform how businesses manage financial and operational processes through our cutting-edge software solutions. We provide secure, efficient access to data and applications from anywhere, enabling seamless collaboration and easy scalability.
            </p>
            <p>
            Our team of experts is committed to delivering high-quality, customized solutions that meet the unique needs of each client. We believe in building long-term relationships based on trust, transparency, and mutual success.
            </p>
            <p>
            Whether you're looking to enhance your financial management, streamline your operations, or leverage the power of cloud computing, Digisoft is here to help you achieve your goals.
            </p>
          
            <a href="#" className="read-more">
              <span>Read More</span><i className="bi bi-arrow-right"></i>
            </a>
          </div>

          <div className="col-xl-7">
            <div className="row gy-4 icon-boxes">

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className="icon-box">
                  <h3>TallyPrime</h3>
                  <p>More than accounting software, TallyPrime gives businesses the foundation for effective financial management with transparent decision-making.</p>
                  <ul className="mt-3">
                    <li>Complete business management platform</li>
                    <li>Seamless accounting & inventory control</li>
                    <li>GST-compliant financial reporting</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
                <div className="icon-box">
                  <h3>DigiCloud</h3>
                  <p>Our flagship cloud service provides businesses with secure, scalable infrastructure for all their application and data needs.</p>
                  <ul className="mt-3">
                    <li>99.9% uptime guarantee</li>
                    <li>Automated backup & disaster recovery</li>
                    <li>24x7 expert technical support</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                <div className="icon-box">
                  <h3>Busy</h3>
                  <p>A robust management tool automating business processes to increase productivity, efficiency, and decision-making for businesses of all sizes.</p>
                  <ul className="mt-3">
                    <li>Comprehensive ERP capabilities</li>
                    <li>Multi-location inventory tracking</li>
                    <li>Advanced financial reporting</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="500">
                <div className="icon-box">
                  <h3>SharePro</h3>
                  <p>A cutting-edge back office solution empowering stockbrokers and financial professionals with streamlined operations.</p>
                  <ul className="mt-3">
                    <li>Seamless Single Sign-In functionality</li>
                    <li>Integrated OS ticket support</li>
                    <li>Enhanced client service tools</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About; 